<div class="container-fluid">
  <div class="row mb-3">
  <div class="col-8">
    <div class="card bg-white">
      <h4 class="card-header bg-white d-flex align-items-center min-height">
        Tender Invitation
        <button *ngIf="user.canManage(tender)" type="button" class="btn btn-light btn-sm ms-auto" (click)="openEditModal()">
          <i class="fas fa-edit me-1"></i>Edit
        </button>
      </h4>
      <div class="card-body" *ngIf="coverLetter && (coverLetter.text || coverLetter.file)">
        <jft-cover-letter [coverLetter]='coverLetter' [tenderId]="tenderId"></jft-cover-letter>
      </div>
      <div class="card-body" *ngIf="!coverLetter || (!coverLetter.text && !coverLetter.file)">
        <p class="text-muted mb-0">Cover letter text was not provided, check Uploaded files for tender details.</p>
      </div>
    </div>

    <div class="card bg-white mt-3" id="invitation-required-documents">
      <h4 class="card-header bg-white d-flex align-items-center min-height">Required Documents</h4>
      <jft-requested-documents [tender]="tender" [documents]="requestedDocuments"
        [readonly]="requestedDocumentsReadonly"></jft-requested-documents>
    </div>
  </div>

  <div class="col-4">
    <div class="card bg-white">
      <h4 class="card-header bg-white d-flex align-items-center min-height">
        Upload Files <small><jft-count [objects]="getAllDocuments()" [initCount]="0"></jft-count></small>
        <div class="ms-auto" *ngIf="user.canManage(tender)">

          <label for="upload-files" class="btn btn-light btn-sm mb-0">
            <i class="fas fa-upload me-1"></i>Upload Files
          </label>
          <input id="upload-files" class="d-none" (change)="addDocumentFiles($event)" type="file" multiple>
        </div>
      </h4>
      <ul class="list-group list-group-flush">
        <li *ngIf="!documents.length && !coverLetter.file"
          class="list-group-item  d-flex align-items-center min-height text-muted">No files to display</li>
        <document-condensed-list *ngIf="coverLetter.file" (documentUpdated)="updateDocumentsEvent($event)"
          [documents]="[coverLetter.file]" [tenderId]="tenderId" [readonly]="!user.canManage(tender)" [class]="'border-bottom'">
        </document-condensed-list>
        <document-condensed-list *ngIf="documents.length" (documentUpdated)="updateDocumentsEvent($event)"
          [documents]="documents" [tenderId]="tenderId" [readonly]="!user.canManage(tender)">
        </document-condensed-list>
      </ul>
    </div>
  </div>
</div>

</div>
